var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cases-item" }, [
    _c(
      "a",
      {
        staticClass: "cases-item__link-wrap",
        attrs: { href: _vm.caseItem.Url }
      },
      [
        _c("div", { staticClass: "cases-item__inner" }, [
          _c(
            "div",
            { staticClass: "cases-item__image-wrap" },
            [
              _vm.caseItem.ImageHtml.Src || _vm.caseItem.ImageHtml.HasCrop
                ? _c("ResponsiveImage", {
                    attrs: {
                      imageModel: _vm.caseItem.ImageHtml,
                      wrapClass: "cases-item__image"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cases-item__text" }, [
            _c("div", { staticClass: "cases-item__text-row" }, [
              _vm.caseItem.HasSegments
                ? _c(
                    "p",
                    {
                      staticClass: "cases-item__preheadline",
                      style: { color: _vm.caseItem.Segments[0].Color }
                    },
                    [_vm._v(_vm._s(_vm.caseItem.Segments[0].Label))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h3", { staticClass: "cases-item__headline" }, [
                _vm._v(_vm._s(_vm.caseItem.Headline))
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b88ea9", { render: render, staticRenderFns: staticRenderFns })
  }
}